// extracted by mini-css-extract-plugin
module.exports = {"highTopMargin":"sd","lowTopMargin":"se","rightColumnWrapper":"sf","rightColumnTitle":"sh","title":"si"};